<template>
  <div class="header_box" :style="{ backgroundColor }">
    <img class="logo" src="@/assets/img/PC/logo.png" />
    <div class="nav_bar">
      <span
        class="LangLabel"
        :style="{ color: color === 'white' ? '#fff' : '' }"
        @click="openLang = !openLang"
        >{{ langLabel }}</span
      >
      <img
        v-if="color === 'white'"
        src="@/assets/img/Mobile/phone_select2.png"
        @click="maskShow = true"
      />
      <img
        v-else
        src="@/assets/img/Mobile/phone_select.png"
        @click="maskShow = true"
      />
    </div>
    <div class="select" v-show="openLang" @mouseleave="openLang = false">
      <div
        class="option"
        v-for="item in langList"
        :key="item.value"
        @click="changeLang(item.value)"
      >
        <span>{{ item.label }}</span>
      </div>
    </div>
    <!-- 遮罩层 -->
    <div class="mask" v-show="maskShow">
      <div class="header_box mask_header">
        <img class="logo" src="@/assets/img/PC/logo.png" />
        <div class="nav_bar">
          <span style="color: #fff">{{ langLabel }}</span>
          <img src="@/assets/img/Mobile/close.png" @click="maskShow = false" />
        </div>
      </div>
      <div class="nav">
        <div>
          <div
            class="nav_item"
            v-for="item in routeList"
            :key="item.value"
            @click="toRoute(item.value)"
          >
            {{ $t(item.label) }}
            <img src="@/assets/img/Mobile/to.png" />
          </div>
          <div
            class="nav_item"
            v-for="item in agreementList"
            :key="item.value"
            @click="toAgreement(item.value)"
          >
            {{ $t(item.label) }}
            <img src="@/assets/img/Mobile/to.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { langList } from "@/locales";
export default {
  props: {
    backgroundColor: {
      type: String,
      default: "#ffffff",
    },
    color: {
      type: String,
      default: "black",
    },
  },
  data() {
    return {
      lang: localStorage.getItem("userLanguage") || "en",
      openLang: false,
      langList: langList,
      maskShow: false,
      routeList: [
        {
          label: "nav_about",
          value: "homeMobile",
        },
        {
          label: "nav_recharge",
          value: "rechargeMobile",
        },
        {
          label: "nav_news",
          value: "newsMobile",
        },
        // {
        //   label: "join",
        //   value: "joinMobile",
        // },
      ],
      agreementList: [
        {
          label: "agrPrivacy",
          value: "privacy",
        },
        {
          label: "agrUser",
          value: "agree",
        },
        {
          label: "agrRecharge",
          value: "recharge",
        },
      ],
    };
  },
  created() {
    let lang = localStorage.getItem("userLanguage");
    if (lang) {
      this.$i18n.locale = lang;
    }
  },
  computed: {
    langLabel() {
      return this.langList.find((el) => el.value == this.lang).label;
    },
  },
  mounted() {
    document.addEventListener("click", this.showSelectMethod);
  },
  destroyed() {
    document.removeEventListener("click", this.showSelectMethod);
  },
  methods: {
    showSelectMethod(e) {
      if (e.target.className != "LangLabel") this.openLang = false;
    },
    toRoute(name) {
      this.maskShow = false;
      this.$router
        .push({
          name,
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeLang(lang) {
      this.lang = lang;
      localStorage.setItem("userLanguage", lang);
      this.$i18n.locale = lang;
    },
    toAgreement(type) {
      window.open(
        "https://oss.guangxijunxuan.cn/h5/agreement/Luukme/" +
          type +
          ".html?lang=" +
          this.lang
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.header_box {
  width: 100%;
  height: 58px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px 0 15px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;

  .logo {
    width: 121px;
    height: 36px;
  }

  .nav_bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333333;
    font-size: 16px;
    font-weight: 400;

    img {
      width: 24px;
      height: 24px;
      margin-left: 29px;
    }
  }
}

.select {
  background-color: #fff;
  position: absolute;
  right: 15px;
  top: 60px;
  border-radius: 8px;
  overflow: hidden;
  font-size: 14px;
  color: #333;

  .option {
    padding: 10px 20px;
    cursor: pointer;

    &:hover {
      background-color: #b8b6bc;
    }
  }
}

.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba($color: #000000, $alpha: 0.8);
  z-index: 999;
  display: flex;
  flex-direction: column;
  .nav {
    margin-top: 15vh;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    height: 100%;
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: center;

    .nav_item {
      margin-bottom: 40px;
      img {
        width: 14px;
        height: 14px;
      }
    }
  }
}

.mask_header {
  position: relative;
  &::after {
    content: "";
    width: calc(100% - 24px);
    border-bottom: 1px solid #5c514e;
    position: absolute;
    bottom: -10px;
    left: 0;
    margin: 0 12px;
  }
}
</style>
